
// This exports the plugin object.
export default {

  install (Vue, options) {
    
    Vue.prototype.$numeral = window.numeral
    
    // 
    //Helper/Shorthand functions
    // 
    // Number Value
    const nVal =  (val) => numeral(val).value()
    
    // Is Number?
    const isN = (val) => val !== undefined && nVal(val) !== null
    
    // Keys for an Object
    const ks = (obj) => obj !== undefined ? Object.keys(obj) : [];
    
    // Keys for an Array of Objects
    const ksArr = (arr) => {
      if (arr === undefined)
        return [];
      if (!Array.isArray(arr))
        return [];
      let keys = [];
      arr.forEach(r => keys = [...keys, ...Object.keys(r)]);
      keys = [...new Set(keys)];
      return keys;
    }

    // 
    // $math
    // 
    const math = {
      keys: (arr) => ksArr(arr),
      sum: (arr) => arr.reduce((acc, r) => acc + nVal(r), 0),
      avg: (arr) => math.sum(arr) / math.count(arr),
      count: (arr) => arr.reduce((acc, r) => acc += isN(r) ? 1 : 0, 0),
      
      sumKey: (arr, key) => arr.reduce((acc, r) => acc + nVal(r[key]), 0),
      avgKey: (arr, key) => math.sumKey(arr, key) / math.countKey(arr, key),
      countKey: (arr, key) => arr.reduce((acc, r) => acc += isN(r[key]) ? 1 : 0, 0),
      
      _keysFunc: (fnName = 'sumKey', arr, keys = ksArr(arr)) => {
        const result = {};
        keys.forEach(k => result[k] = math[fnName](arr, k))
        return result;
      },
      sumKeys: (arr) => math._keysFunc('sumKey', arr),
      avgKeys: (arr) => math._keysFunc('avgKey', arr),
      countKeys: (arr) => math._keysFunc('countKey', arr),

      _subKeysFunc: (fnName = 'sumKey', obj, keys = ks(obj)) => {
        const result = {};
        keys.forEach(k => {
          result[k] = math[fnName](obj[k])
        })
        return result;
      },
      sumSubKeys: (obj) => math._subKeysFunc('sumKeys', obj),
      avgSubKeys: (obj) => math._subKeysFunc('avgKeys', obj),
      countSubKeys: (obj) => math._subKeysFunc('countKeys', obj),
      
      _subSubKeysFunc: (fnName = 'sumKey', obj, willRollup = false, keys = ks(obj)) => {
        const result = math._subKeysFunc(fnName, obj);
        if (willRollup){
          let rollup = {}
          keys.forEach(k=> {
            ks(obj[k]).forEach(ks=>{
              rollup[ks] = rollup[ks] === undefined ? [] : rollup[ks];
              rollup[ks] = [...rollup[ks], ...(Array.isArray(obj[k][ks]) ? obj[k][ks] : [obj[k][ks]])]
            })
          })
          return math[fnName](rollup)
        } else {
          return result;
        }
      },

      sumSubSubKeys: (obj, willRollup) => math._subSubKeysFunc('sumSubKeys', obj, willRollup),
      avgSubSubKeys: (obj, willRollup) => math._subSubKeysFunc('avgSubKeys', obj, willRollup),
      countSubSubKeys: (obj, willRollup) => math._subSubKeysFunc('countSubKeys', obj, willRollup),

      subtotalsForKey(arr, subtotalKey){
        const result = [];

        let subtotalValues = Vue.prototype.$util.valuesForKeyPath(arr, subtotalKey)
        subtotalValues = subtotalValues.map(r=> r instanceof Date ? moment(r).format('YYYY-MM-DD[T]HH:mm:ss.000[Z]') : r);
        subtotalValues = Vue.prototype.$util.uniqueValues(subtotalValues)
        
        subtotalValues.forEach(v=>{
          // let valueForKey;
          const subtotal = math.sumKeys(arr.filter(r=>{
            // valueForKey = r[subtotalKey];
            return (r[subtotalKey] instanceof Date ? moment(r[subtotalKey]).format('YYYY-MM-DD[T]HH:mm:ss.000[Z]') : r[subtotalKey]) === v
          }))
          subtotal[subtotalKey] = v
          result.push(subtotal)
        })
        return result;
      },

      diffKeys: (obj1, obj2) => {
        const result = {}
        ks(obj1).forEach(k=>result[k] = nVal(obj1[k]) - nVal(obj2[k]))
        return result;
      },
      diffSubKeys: (obj1, obj2) => {
        const result = {}
        ks(obj1).forEach(k=>result[k] = math.diffKeys(obj1[k], obj2[k]))
        return result;
      },
      
      percentDiffKeys: (obj1, obj2) => {
        const result = {}
        ks(obj1).forEach(k=>result[k] = (nVal(obj1[k]) - nVal(obj2[k])) / nVal(obj2[k]))
        return result;
      },
      percentDiffSubKeys: (obj1, obj2) => {
        const result = {}
        ks(obj1).forEach(k=>result[k] = math.percentDiffKeys(obj1[k], obj2[k]))
        return result;
      },
    }
    
    Vue.prototype.$math = math
    

    // test()
    // this should be refactored elsewhere
    function test(){
      console.log('DEBUG Math')
      const testArr = [1,2,3,4,5,'asdf', undefined]
      console.log('sum', math.sum(testArr));
      console.log('avg', math.avg(testArr));
      console.log('count', math.count(testArr));
      // console.log('countA', math.countA(testArr));
      
      console.log('DEBUG Math Key')
      const testObj1 = [{a:1},{a:2},{a:3},{a:4},{a:5},{a:'asdf'}, {}]
      console.log('sum', math.sumKey(testObj1, 'a'));
      console.log('avg', math.avgKey(testObj1, 'a'));
      console.log('count', math.countKey(testObj1, 'a'));
      
      console.log('DEBUG Math Keys')
      const testObj2 = [{a:1, b:10},{a:2, b:20},{a:3, b:30},{a:4, b:40},{a:5, b:50},{a:'asdf'}, {}]
      console.log('sum', math.sumKeys(testObj2));
      console.log('avg', math.avgKeys(testObj2));
      console.log('count', math.countKeys(testObj2));
      
      console.log('DEBUG Math SubKeys')
      const testObj3 = {
        topSales: [{a:1, b:10},{a:2, b:20},{a:3, b:30},{a:4, b:40},{a:5, b:50},{a:'asdf'}, {}],
        popSales: [{a:0, b:0},{a:2, b:20},{a:3, b:30},{a:4, b:40},{a:5, b:50},{a:'asdf'}, {}],
      }
      console.log('sum', math.sumSubKeys(testObj3));
      console.log('avg', math.avgSubKeys(testObj3));
      console.log('count', math.countSubKeys(testObj3));
      
      console.log('DEBUG Math SubSubKeys')
      const testObj4 = {
        RCGB: {topSales: [{a:1, b:10},{a:2, b:20},{a:3, b:30},{a:4, b:40},{a:5, b:50},{a:'asdf'}, {}]},
        RMGB: {topSales: [{a:0, b:0},{a:2, b:20},{a:3, b:30},{a:4, b:40},{a:5, b:50},{a:'asdf'}, {}]},
      }
      console.log('sum', math.sumSubSubKeys(testObj4));
      console.log('avg', math.avgSubSubKeys(testObj4));
      console.log('count', math.countSubSubKeys(testObj4));
      
      console.log('DEBUG Math SubSubKeys with rollup')
      console.log('sum', math.sumSubSubKeys(testObj4, true));
      console.log('avg', math.avgSubSubKeys(testObj4, true));
      console.log('count', math.countSubSubKeys(testObj4, true));
    }

  }
}